/**
 * 高级设置-报名预警
 * @author ariel
 * @date 2023-02-16
 */
import React from "react";
import {component_tool, framework_tool} from '../../../tool'
import { WizTableForm } from '@/containers/common';
import moment from "moment";

const {WizComponent, WizForm, WizRow, WizCol, WizInputNumber, WizTooltip, WizIcon} = component_tool
const {WizAvatarUpload} = framework_tool

const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1 } })

export default class WizApplyWarningSet extends WizComponent {
  constructor(props) {
    super(props);
    this.state={
    }
  }

  _onApplyWarningSubmit(values) {
    let {submit, record} = this.props;
    values['warningDate'] = moment(values['warningDate'] || record['warningDate']).format("YYYY-MM-DD HH:mm:ss")
    submit(values)
  }

  warningPersonValidator = (rule, value, callback) => {
    if (value.length === 0) {
      wizNotice.warn('请选择预警人')
      callback('请选择预警人')
    }
    if (value && value.length > 200) {
      wizNotice.warn('预警人最多选择200个')
      callback('预警人最多选择200个')
    }
    callback();
  }

  render() {
    let {record} = this.props
    let columns = []
    columns = columns.concat([
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: record && record.id
        }
      },
      {
        name: 'applyId',
        formItem: {
          type: 'hidden',
          initialValue: record && record.applyId
        }
      },
      {
        title: '报名名称',
        name: 'applyName',
        formItem: {
          initialValue: record && record.applyName,
          disabled: true
        }
      },
      {
        title: '预警人',
        name: 'personIdList',
        formItem: {
          rules: [
            {
              validator: this.warningPersonValidator
            },
          ],
          ...userConfig,
          placeholder: '请选择预警人',
          title: '预警人选择',
          diy: WizTableForm,
          initialValue: record && record.personIdList,
          initRows: record && record.personList,
          selectType: 'checkbox',
        }
      },
      {
        title: '预警时间',
        name: 'warningDate',
        formItem: {
          initialValue: record && record.warningDate ? record.warningDate : null,
          type: 'date',
          rules: [
            {
              required: true,
              message: '预警时间必填'
            }
          ],
          format: 'YYYY-MM-DD HH:mm',
          showTime: {
            format: 'HH:mm'
          }
        }
      },
      {
        title: '报名人员比例',
        name: 'applyRate',
        formItem: {
          type: 'custom',
          render: (info, form) => {
            const { getFieldDecorator } = form
            return (
              <WizRow>
                <WizCol style={{ marginRight: 15 }}  span={5}>
                  {
                    getFieldDecorator('applyRate', {
                      rules: [
                        { required: true, message: '请输入报名人员比例要求', },
                      ],
                      initialValue: record.id ? record.applyRate : 1
                    })(
                      <WizInputNumber placeholder={'请输入报名人员比例'} min={1} max={100} />
                    )
                  }
                </WizCol>
                <WizCol style={{ marginRight: 10 }} span={1}>
                  %
                </WizCol>
                <WizCol>
                  <WizTooltip title={'报名人员比例要求（已报名人数/可报名人数*100):当报名人数没有达到要求时，对相关人员进行预警，在报名截止时间前进行报名预警的提醒。'}>
                    <WizIcon type='question-circle-o'/>
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: "通知类型",
        name: "typeList",
        dict: [
          { code: 0, codeName: '站内通知' },
          { code: 1, codeName: '短信通知' },
        ],
        formItem: {
          type: 'checkbox',
          initialValue: record && record.typeList && record.typeList.length>0 ? record.typeList : [0,1],
          rules: [
            {
              required: true,
              message: '通知类型必选'
            }
          ],
        }
      },
      {
        title: "状态",
        name: "state",
        dict: [
          { code: 1, codeName: '有效' },
          { code: 0, codeName: '无效' },
        ],
        formItem: {
          type: 'radio',
          initialValue: record.id ? record.state : 1,
          rules: [
            {
              required: true,
              message: '状态必选'
            }
          ],
        }
      },
    ])

    let onApplyWarningSubmit = this._onApplyWarningSubmit.bind(this)

    let formProps = {
      ref: 'form',
      key: new Date().getTime(),
      columns: columns,
      onSubmit: onApplyWarningSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    return (
      <>
        <WizForm {...formProps} />
      </>
    )
  }

}

WizApplyWarningSet.defaultProps = {}

WizApplyWarningSet.propTypes = {}
